<!-- Depots Table  -->

<div class="depot_listing_page">
  <div class="col-md-12" *ngIf="isLoading">
    <app-busy [message]="message"></app-busy>
  </div>
  <!-- <div class="blue_header">
    <h1 class="heading">Carrier Depot</h1>
  </div> -->
  <!-- <img src="../../../../../assets/newimg/arrow-1-3@2x.png"  style="cursor: pointer;margin: 10px;" /> -->

  <!-- <app-filter [code]="code" [description]="description" [selectedItems]="selectedItems"
          (formValueChanged)="applyFilter($event)"></app-filter> -->

  <!-- <div class="page_header">
    <h1 class="heading">Depots</h1>
    <p class="name">{{ user?.UserName }}</p>
  </div>
  <img
    src="../../../assets/newimg/arrow-1-3@2x.png"
    style="cursor: pointer; margin: 10px"
  /> -->
  <!-- [routerLink]="['/carrier/accounts/VCA']" -->
  <!-- <div class="add_btn_wrap flex_end" style="float: right">
    <button type="button" (click)="onAddDepot()" class="btn btn_primary">
      + Add Depot
    </button>
  </div> -->

  <ng-template #content let-modal>
    <div class="modal-header">
      <h4 class="modal-title" id="modal-basic-title">Delete Confirmation</h4>
      <button
        type="button"
        class="btn-close"
        aria-label="Close"
        (click)="modal.dismiss('Cross click')"
      >
        &times;
      </button>
    </div>
    <div class="modal-body">
      <input type="hidden" [(ngModel)]="removeRef" name="id" />
      <span [innerHTML]="deleteConfirm"></span>
    </div>
    <div class="modal-footer">
      <button
        class="btn btn-danger btn-sm"
        (click)="onDelete(removeRef.id)"
        style="width: 80px"
      >
        Yes
      </button>
      <button
        class="btn btn-default btn-sm"
        (click)="modal.dismiss('Cross click')"
        style="width: 80px"
      >
        No
      </button>
    </div>
  </ng-template>

  <div class="table-responsive">
    <table class="table custom_table">
      <thead>
        <!-- <th>
          <input type="checkbox" value="" id="" name="" />
        </th> -->
        <th>Name</th>
        <th>Depot type</th>
        <th>Number of Vehicles</th>
        <th>RCP</th>
        <th>Dial Code Telephone</th>
        <th>Town</th>
        <th>Actions</th>
      </thead>
      <tbody>
        <tr
          *ngFor="
            let depot of carrierDepotList
              | paginate : { itemsPerPage: 10, currentPage: page }
          "
        >
          <td>{{ depot.first_name }}</td>
          <td>{{ depot.depot_type }}</td>
          <td>{{ depot.number_of_vehicles }}</td>
          <td>{{ depot.first_name }} {{ depot.last_name }}</td>
          <td>{{ depot.dial_code_tele }} {{ depot.cellphone }}</td>
          <td>{{ depot.physical_address_town }}</td>
          <td>
            <div class="actions">
              <button
                type="button"
                (click)="onViewDetails(depot)"
                class="btn_icon"
                aria-label="View file"
              >
                <img src="assets/visibility.png" alt="" />
              </button>
            </div>
          </td>
        </tr>
      </tbody>
      <tfoot>
        <tr *ngIf="count > 10" class="pagination_row">
          <td colspan="12" class="rm-brd">
            <div class="row">
              <div class="col-2">
                <div
                  class="input-group mb-3 rm-brd"
                  style="width: 125px !important; height: 30px !important"
                >
                  <div class="input-group-prepend">
                    <label
                      class="input-group-text form-control-sm show-h"
                      for="show-id"
                      >Show:</label
                    >
                  </div>
                  <select
                    class="form-control form-control-sm show-h"
                    id="show-id"
                    [(ngModel)]="pageSize"
                    (change)="onChange()"
                  >
                    <option
                      *ngFor="let key of utility.pageItems"
                      [ngValue]="key"
                    >
                      {{ key }}
                    </option>
                  </select>
                </div>
              </div>
              <div class="col-10">
                <pagination-controls
                  (pageChange)="utility.page = onNextOrPrevious($event)"
                  style="margin-right: 0px !important; float: right !important"
                ></pagination-controls>
              </div>
            </div>
          </td>
        </tr>
        <tr *ngIf="isEmpty">
          <td colspan="4" class="rm-brd">
            <span class="text-info text-small">No carrier depots found.</span>
          </td>
        </tr>
      </tfoot>
    </table>
  </div>
</div>
 <!-- Depot View Details modal -->
 <ng-template #detailViewDetails let-modal>
  <div class="modal-header">
    <h4 class="modal-title" id="modal-basic-title">Depot Details</h4>
    <button
      type="button"
      class="btn-close"
      aria-label="Close"
      (click)="modal.dismiss('Cross click')"
    >
      &times;
    </button>
  </div>
  <div class="modal-body">
    <app-carrier-depot-details [carrierId]="carrierId" [depotDetails]="depot" (saved)="modal.dismiss('Cross click')"></app-carrier-depot-details>
  </div>
</ng-template>